import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const FlipFlopsModule = () => (
  <DSDModuleSubtopic
    title="Flip Flops"
    videos={[
      "https://www.youtube.com/embed/LTtuYeSmJ2g",
      "https://www.youtube.com/embed/QWMpq6NLwF4",
      "https://www.youtube.com/embed/EILb-DrYr8A",
      "https://www.youtube.com/embed/CiS7N2C8-Ik",
      "https://www.youtube.com/embed/LOPHyHOMcLI",
      "https://www.youtube.com/embed/bl77FRTAXWA",
      "https://www.youtube.com/embed/n_iDg_6sUqA",
      "https://www.youtube.com/embed/u3jI1NKwsnM",
      "https://www.youtube.com/embed/bg65gCzDNhA",
      "https://www.youtube.com/embed/JPpSwtpnmU8",
      "https://www.youtube.com/embed/kuZYCrfUgFc"
    ]}
    takeaways={[
      {text:"Copy all the Verilog codes of all the flip flops"},
      {text:"Learn how to write flip flop code in general; there is a chance of asking code for any new flip flop based on the scenario."}
    ]}
    questions={[
      {
        text: "In the sequential circuit using JK Flip Flop given below, assume that the initial value of Q1=0 and Q2=1 and give the function table and draw the wave sequences of the outputs Q1 and Q2 for 6 positive edge clock cycles.",
        image:"/dsd_15.png"
      },
      {
        text: "Identify the flip-flop and write its characteristic table and equation from the following timing diagram. Convert it into D flip-flop.",
        image:"/dsd_16.png"
      },
      {
        text: "Design a D-Flip Flop using T Flip Flop and write the Verilog Code for the above design using structural modelling."
      },
      {
        text: `A New clocked X-Y flip-flop is defined with two inputs, X and Y in addition to the clocked input. The flip flop functions as follows:
i. If XY=01, the flip flop state (Q) becomes 1 at the next clock pulse.
ii. If XY=10, the flip flop state (Q) becomes 0 at the next clock pulse.
iii. If X=Y, the flip flop toggles its state (Q) at the next clock pulse.
Provide the truth table, characteristics table, excitation table for the X-Y flip flop, and implement X-Y flip flop using a J-K flip flop.`
      },
      {
        text: "Compare JK and T Flip Flops with neat circuit diagram using AOI logic, waveforms and truth-tables."
      },
      {
        text: `A BC Flip-Flop has four operations: clear to 0, no change, complement, and set to 1, when inputs B and C are 11, 10, 01, and 00 respectively
a) Tabulate the characteristic table
b) Derive the characteristic equation
c) Tabulate the excitation table
d) Show how the BC Flip Flop can be converted to a D Flip."`
      },
      {
        text: `Design the Flip Flop A using Flip Flop B and some basic logical components.
The Characteristics table of Flip Flop A which has two input A1 and A2 is as follows: The flip flop next state is said to be set if all of its inputs are same (A1=A2) and reset for all combination.
The Excitation Table of Flip Flop B which have 2 inputs B1 and B2 can be obtained from the following condition. If the present state and next state are equal, the inputs are 1 and 0 (B1=1 and B2=0) and for rest possible combinations of the present state and next, the inputs are 0 and 1.`
      },
      {
        text: `A PN Flip-Flop has four operations: clear to 0, no change, complement, and set to 1, when inputs P and N are 01, 00, 11, and 10 respectively
a) Tabulate the characteristic table
b) Derive the characteristic equation
c) Tabulate the excitation table
d) Show how the PN Flip-Flop can be converted to a D Flip Flop.`
      },
      {
        text: "Design a JK Flip Flop using D Flip Flop. Write a Verilog Code for the design using Structural Modelling."
      },
      {
        text: `A Sequential circuit with 2 D flip-flops A and B, one input x, and one output Z is specified by the following next state and output equations.
A(t+1)=A'+B, B(t+1)=B'x, Z=A+B'
i) Draw the logic diagram
ii) Derive the state table
iii) Derive the state diagram
iv) Write behavioral level Verilog code for the above circuit with line by line comments.`
      },
      {
        text: "Design the Sequential circuit for the following state diagram using JK Flip Flop.",
        image:"/dsd_17.png"
      },
      {
        text: `Consider the following state diagram for a circuit with one input X and one output Z. Analyse this state diagram and draw its circuit implementation using JK Flip Flop (State Q0) and T Flip Flop (State Q1) and 4:1 MUX for Z.`,
        image:"/dsd_18.png"
      },
      {
        text: `Determine the Qa and Qa' when C and D are 00,01,10 and 11. Assume the initial condition of Qa and Qa' as 0 and 1 respectively. Also write the behavioral code for the identified CD flip flop.`,
        image:"/dsd_19.png"
      },
      {
        text: "Develop a verilog program in behavioral modelling (including Full adder and D Flip flop) along with test bench for the following sequential circuit.",
        image:"/dsd_20.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default FlipFlopsModule;
